/* eslint jsx-a11y/click-events-have-key-events:0 */
/* eslint jsx-a11y/no-static-element-interactions:0 */
/* eslint jsx-a11y/onclick-has-focus:0 */
//@flow
import * as React from 'react';
import BrowserExperimentClient from 'app/common/lib/ExperimentsClient/browser';
import i18n from 'app/common/lib/i18n';
import ImageUploader from 'app/common/lib/react/imageUploader';
import ResourceFactory from 'app/common/lib/ResourceFactory';
import urlUtil from 'app/common/lib/urlUtil';
import { ModalNames } from 'app/common/react/components/profile/UserProfileHeader/ModalContents/ModalNames';
import { RequestContextConsumer } from 'app/common/react/components/RequestContext';
import { Button, SelectList, TextArea, TextField, Text, Box, Label, Modal, Divider } from 'gestalt';

const hasContent = (str) => Boolean(str.trim());
type Props = {
  advertiserId?: string,
  onClearModal: Function,
  username: string,
};
type State = {
  bugtype: string,
  confirmModal: boolean,
  description: string,
  imageUrl: string | null,
  isSubmitting: boolean,
  title: string,
  uploadComplete: boolean | string, // contains file name when complete
  uploadPercent: number | null,
};
type ServerData = {
  image_url: string,
};
export class ReportBug extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      bugtype: 'FEATURE_ERROR',
      confirmModal: false,
      description: '',
      imageUrl: null,
      isSubmitting: false,
      title: '',
      uploadComplete: false, // contains file name when complete
      uploadPercent: null,
    };
  }
  componentDidMount() {
    const { handleUploadSuccess, handleUploadFailure, uploadProgress } = this;

    const imageUploader = new ImageUploader();

    imageUploader.enableUploader(
      this.button,
      uploadProgress,
      handleUploadSuccess,
      handleUploadFailure,
    );
  }
  // $FlowFixMe Flow v0.104.0 upgrade supression.
  button: *;

  handleSelectListChange = ({ value }: { value: string }) => {
    this.setState({
      bugtype: value,
    });
  };

  handleSubmit = (activeExperiments: string) => (event: SyntheticEvent<>) => {
    event.preventDefault();
    event.stopPropagation();

    this.setState({
      isSubmitting: true,
    });
    const userAgent = window.navigator.userAgent;
    const url = urlUtil.getCurrentUrl();

    let userImpact;
    switch (this.state.bugtype) {
      case 'FEATURE_ERROR':
        userImpact = 'Functionality';
        break;
      case 'IRRELEVANT_RESULT':
        userImpact = 'Relevance';
        break;
      case 'DESIGN_ERROR':
        userImpact = 'Visual';
        break;
      case 'COPY_ERROR':
        userImpact = 'Linguistic';
        break;
      default:
        userImpact = 'Functionality';
    }

    const options = {
      activatedExperiments: activeExperiments,
      bugtype: this.state.bugtype,
      description: this.state.description,
      environment: userAgent,
      platform: 'web',
      title: this.state.title,
      url,
      userImpact,
      username: this.props.username,
      advertiserId: this.props.advertiserId,
      image_url: this.state.imageUrl,
      filename: this.state.uploadComplete,
    };

    if (this.state.imageUrl) {
      options.image_url = this.state.imageUrl;
      options.filename = this.state.uploadComplete;
    }

    const resource = ResourceFactory.create('ReportErrorResource', options);
    resource
      .callCreate()
      .then((resourceResponse) => {
        const responseData = resourceResponse.resource_response.data;
        if (responseData.errorMessages) {
          this.setState({
            confirmModal: ModalNames.reportBugFailure,
            isSubmitting: false,
          });
        } else {
          this.setState({
            confirmModal: ModalNames.reportBugSuccess,
            isSubmitting: false,
          });
        }
      })
      .catch(() => {
        this.setState({
          isSubmitting: false,
          confirmModal: ModalNames.reportBugFailure,
        });
      });
  };

  handleClearFailure = () => {
    this.setState({
      confirmModal: false,
    });
  };

  handleUploadFailure = () => {
    this.setState({
      uploadComplete: i18n._('Upload failed!'),
      uploadPercent: null,
    });
  };

  handleUploadSuccess = (_: any, fileName: string, data: ServerData) => {
    this.setState({
      imageUrl: data.image_url,
      uploadComplete: fileName,
      uploadPercent: null,
    });
  };

  handleTitleChange = ({ value: str }: { value: string }) => {
    this.setState({
      title: str,
    });
  };

  handleDescriptionChange = ({ value: str }: { value: string }) => {
    this.setState({
      description: str,
    });
  };

  uploadProgress = (loaded: number, total: number, uploadPercent: number) => {
    this.setState({
      uploadPercent,
      uploadComplete: false,
    });
  };

  render() {
    const { onClearModal } = this.props;
    const { handleClearFailure, handleSubmit } = this;
    const {
      bugtype,
      confirmModal,
      description,
      isSubmitting,
      uploadComplete,
      uploadPercent,
      title,
    } = this.state;

    const bugTypes = [
      { value: 'FEATURE_ERROR', label: i18n._('Something is broken') },
      {
        value: 'IRRELEVANT_RESULTS',
        label: i18n._('Irrelevant search, Pin, or ad'),
      },
      { value: 'DESIGN_ERROR', label: i18n._('Design is wrong') },
      { value: 'COPY_ERROR', label: i18n._('Translation or copy is wrong') },
    ];

    let uploaderProgress = null;
    if (uploadComplete) {
      uploaderProgress = uploadComplete;
    } else if (uploadPercent) {
      uploaderProgress = uploadPercent + '%';
    }
    const isSubmittable = hasContent(title) && hasContent(description);

    return (
      <RequestContextConsumer>
        {(requestContext) => (
          <form
            method="post"
            onSubmit={handleSubmit(
              requestContext.experiments instanceof BrowserExperimentClient
                ? JSON.stringify(requestContext.experiments.active, null, '\t')
                : '{}',
            )}
          >
            <Box color="white" paddingX={4} paddingY={5} width={500}>
              <Text align="center" size="xl" weight="bold">
                {i18n._('Report a Bug')}
              </Text>
              <Box paddingY={3}>
                <Divider />
              </Box>
              <Box display="flex" direction="column">
                <Box
                  paddingX={2}
                  paddingY={2}
                  display="flex"
                  direction="column"
                  alignItems="stretch"
                >
                  <Label htmlFor="bugTitle">
                    <Text>{i18n._('Description (Required)')}</Text>
                  </Label>
                  <Box paddingY={1}>
                    <TextField
                      id="bugTitle"
                      name="title"
                      onChange={this.handleTitleChange}
                      type="text"
                      value={this.state.title}
                    />
                  </Box>
                </Box>
                <Box
                  paddingX={2}
                  paddingY={4}
                  display="flex"
                  direction="column"
                  alignItems="stretch"
                >
                  <Box>
                    <Label htmlFor="description">
                      <Text>{i18n._('Steps to Reproduce (Required)')}</Text>
                    </Label>
                  </Box>
                  <Box paddingY={1}>
                    <TextArea
                      id="description"
                      name="description"
                      onChange={this.handleDescriptionChange}
                      value={this.state.description}
                    />
                  </Box>
                </Box>
                <Box
                  paddingX={2}
                  paddingY={4}
                  display="flex"
                  direction="column"
                  alignItems="stretch"
                >
                  <Box>
                    <Label htmlFor="bugtype">
                      <Text>{i18n._('Type', 'type as in variety or kind')}</Text>
                    </Label>
                  </Box>
                  <Box paddingY={1}>
                    <SelectList
                      id="bugtype"
                      name="bugtype"
                      onChange={this.handleSelectListChange}
                      options={bugTypes}
                      value={bugtype}
                    />
                  </Box>
                </Box>
                <Box
                  paddingX={2}
                  paddingY={4}
                  display="flex"
                  direction="column"
                  alignItems="stretch"
                >
                  <Box paddingY={1}>
                    <Text>{i18n._('Attach a Screenshot')}</Text>
                  </Box>
                  <Box
                    alignItems="center"
                    direction="row"
                    display="flex"
                    marginstart={-1}
                    marginend={-1}
                  >
                    <div
                      ref={(ref) => {
                        this.button = ref;
                      }}
                      style={{ overflow: 'visible', float: 'left' }}
                    >
                      <Button text={i18n._('Choose file')} size="sm" type="button" color="gray" />
                    </div>
                    <Box flex="grow" paddingX={2}>
                      <Text size="sm" align="left">
                        {uploaderProgress || i18n._('None')}
                      </Text>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box paddingY={3}>
                <Divider />
              </Box>
              <Box>
                <Box display="flex" justifyContent="end" direction="row" paddingY={2}>
                  <Box paddingX={2}>
                    <Button
                      disabled={!isSubmittable}
                      text={i18n._('Report')}
                      type="submit"
                      color="red"
                    />
                  </Box>
                  {confirmModal && (
                    <Modal
                      accessibilityCloseLabel={i18n._('Close', 'hide the view')}
                      accessibilityModalLabel={i18n._('View Bug Report Submission Status')}
                      heading={
                        confirmModal === ModalNames.reportBugSuccess
                          ? i18n._('Bug Reported!')
                          : i18n._('Oops!')
                      }
                      onDismiss={
                        confirmModal === ModalNames.reportBugFailure
                          ? handleClearFailure
                          : onClearModal
                      }
                    >
                      <Box paddingX={4} paddingY={4}>
                        <Text>
                          {confirmModal === ModalNames.reportBugSuccess
                            ? i18n._(
                                'Sorry about that. We’ve been notified and will work on a fix! High-five for reporting. ',
                              )
                            : i18n._(
                                'Something went wrong and we were unable to report your bug. We’re looking into it!',
                              )}
                        </Text>
                      </Box>
                    </Modal>
                  )}
                </Box>
                {isSubmitting && (
                  <Box
                    display="flex"
                    justifyContent="end"
                    direction="row"
                    paddingY={2}
                    paddingX={2}
                  >
                    <Text>{i18n._('Submitting...')}</Text>
                  </Box>
                )}
              </Box>
            </Box>
          </form>
        )}
      </RequestContextConsumer>
    );
  }
}

export default ReportBug;
